<template>
  <div>
    <!-- 筛选列表 -->
    <TopSlideSheet v-model:isShow="showFilter">
      <template #content>
        <div class="filter_list">
          <h1 class="title" v-if="!category_lv1_id && tagsItem1.length > 2">一级分类</h1>
          <van-row v-if="!category_lv1_id && tagsItem1.length > 2">
            <van-col span="6" v-for="(item, index) in tagsItem1">
              <span @click="clickCate1(index)" :class="{'text_ellipsis': true, 'active': item.id === activeItemId}" :key="item.id">{{ item.name }}</span>
            </van-col>
          </van-row>
          <h1 class="title" v-if="category_lv1_id || tagsItem1.length <= 2">分类</h1>
          <h1 class="title" v-else>二级分类</h1>
          <van-row>
            <van-col span="6" v-for="(item, index) in tagsItem2" :style="(category_lv1_id || tagsItem1.length <= 2 || item.id == 0 || item.parent_id == activeItemId || activeItemId == 0) ? 'display: block;' : 'display: none'">
              <span @click="clickCate2(index)" :class="{'text_ellipsis': true, 'active': item.active === true}" :key="item.id">{{ item.name }}</span>
            </van-col>
          </van-row>
          <div class="text-right buttons">
            <van-button type="default" round size="normal" @click="showFilter = false">取消</van-button>
            <van-button type="primary" round size="normal" @click="filterConfirm">确定</van-button>
          </div>
        </div>
      </template>
    </TopSlideSheet>
    <!-- 快捷筛选 -->
    <div class="filter_wrap" v-if="initCate">
      <div v-if="filterActiveList.length !== 0" class="filter_active_list">
        <span>
          <span v-for="(item, index) in filterActiveList" :key="index">{{ item.name }}</span>
          <van-icon name="clear" class="clear_filter_btn" @click="clearFilter" />
        </span>
      </div>
      <div v-else>
        <ul class="clearfix" v-if="!category_lv1_id && tagsItem1.length > 2">
          <li v-for="(item, index) in tagsItem1.slice(0, 4)" :class="{'active': item.id === activeItemId}" @click="clickCate1(index, true)" :key="item.id">{{ item.name }}</li>
        </ul>
        <ul class="clearfix" v-if="category_lv1_id || tagsItem1.length <= 2">
          <li v-for="(item, index) in tagsItem2.slice(0, 4)" :class="{'active': item.active === true}" @click="clickCate2(index, true)" :key="item.id">{{ item.name }}</li>
        </ul>
      </div>
      <van-icon name="filter-o" class="filter_btn" @click="loadFilter" />
    </div>

    <!-- 课程列表 -->
    <div class="container bg_gray">

      <h3 class="list_title" v-if="title !== ''"><span class="span-icon"></span>{{ title }}</h3>

      <LoadList :pager="pager" v-model:loading="loading" v-model:finished="finished" @getPager="getPager">
        <van-row gutter="15">
          <van-col span="12" v-for="(item, index) in courseItem" :key="index">
            <div class="card_item_common">
              <div class="cover" @click="goPathToNewPage('/mobile/course/detail/' + item.uuid)">
                <img :src="item.cover_image" class="image">
                <span class="hot" v-if="item.cover_image_label && item.cover_image_label != 'null'">{{ item.cover_image_label }}</span>
                <span class="tag" v-if="item.type">{{ item.type }}</span>
              </div>
              <div class="content">
                <div class="title text_ellipsis" @click="goPathToNewPage('/mobile/course/detail/' + item.uuid)">{{ item.name }}</div>
                <div class="price_wrap" v-if="showPrice">
                  <van-tag v-if="item.final_price == 0">免费</van-tag>
                  <span class="discount_price" v-else><span>¥</span>{{ item.final_price }}</span>
                  <span class="price" v-if="item.mark_price">¥ {{ item.mark_price }}</span>
                </div>
              </div>
            </div>
          </van-col>
          <van-col span="12" v-if="courseItem.length % 2 !== 0"></van-col>
        </van-row>
      </LoadList>
    </div>
  </div>
</template>

<script>
import LoadList from "components/mobile/common/LoadList"
import TopSlideSheet from "components/mobile/common/TopSlideSheet"
import { goPathToNewPage } from 'utils/common'
import { listCate } from "api/course/cate/list"
import { listUserCur } from "api/course/course/list"
import { get_favor_like } from "api/course/course/create"
// import Pagination from "components/common/Pagination"
export default {
  name: 'CurList',
  props: {
    initCate: {
      type: Boolean,
      default: true
    },
    initAuth: {
      type: Boolean,
      default: true
    },
    category_lv1_id: {
      type: String,
      default: '',
    },
    category_lv2_ids: {
      type: String,
      default: '',
    },
    curFilter: {
      type: Object,
      default: {}
    },
    filters: {
      type: Object,
      default: {}
    },
    title: {
      type: String,
      default: ''
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    zone_uuid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      filterActiveList: [],
      showFilter: false,
      firstInit: true,
      activeItemId: 0,
      tagsItem1: [{
        id: 0,
        name: '全部',
        active: true,
      }],
      tagsItem2: [{
        id: 0,
        name: '全部',
        active: true
      }],
      courseItem: [],
      pager: {},
      hasAuth: false,
      activeAuth: 0,
      loading: false,
      finished: false
    }
  },
  components: {
    // Pagination,
    LoadList,
    TopSlideSheet
  },
  mounted(){
    this.$emit('update:isShowHeader', true)

    this.pager = {
      pageSize: 12,
      currentPage: 0,
      total: 0
    }
    if(this.initCate) {
      this.getCateList()
    }
  },
  methods: {
    goPathToNewPage,
    loadFilter() {
      let that = this
      that.showFilter = true
      if(that.filterActiveList.length == 0){
        this.clickCate1(0, false)
        this.clickCate2(0, false)
      }
      else {
        this.activeItemId = that.filterActiveList[0].id
        for(let i=0; i<that.tagsItem2.length; i++){
          if(that.tagsItem2[i].id == that.filterActiveList[that.filterActiveList.length - 1].id){
            that.tagsItem2[i].active = true
          }
          else {
            that.tagsItem2[i].active = false
          }
        }
      }
    },
    filterConfirm() {
      this.filterActiveList = new Array()
      let tagsActiveItem1, tagsActiveItem2;
      if(!this.category_lv1_id && this.tagsItem1.length > 2) {  //有一级分类
          const that = this
          tagsActiveItem1 = this.tagsItem1.filter(item=>{
            return item.id === that.activeItemId;
          });
          this.filterActiveList.push(tagsActiveItem1[0]);
      }
      tagsActiveItem2 = this.tagsItem2.filter(item=>{
        return item.active === true;
      });
      this.filterActiveList.push(tagsActiveItem2[0]);
      this.activeItemId = this.filterActiveList[0].id
      this.showFilter = false;
      this.resetPager()
      //列表查询更新
    },
    clearFilter() {
      this.filterActiveList = []
      this.clickCate1(0, false)
      this.clickCate2(0, false)
      this.resetPager()
    },
    getFavorLike(courseItem){
      courseItem.forEach(item => {
        get_favor_like(item.uuid).then(res => {
          item.like = res.like.num
          item.favor = res.favor.num
          item.view = res.view_num
        })
      })
    },
    getCurList() {
      const that = this
      let filters = {state: 3, need_info: true, need_type: true}
      filters = Object.assign(filters, that.filters)
      if (that.activeAuth != 0) {
        filters['auth_type'] = that.activeAuth
      }
      if(Object.keys(that.curFilter).length > 0){ // 查询课程集合
        if(that.curFilter.chapter_include == 1){  // 全为
          if(typeof that.curFilter.chapter_type == 'string'){
            filters['type'] = that.curFilter.chapter_type
          }
          else{
            filters['type'] = that.curFilter.chapter_type[0]
          }
        }
        else if(that.curFilter.chapter_include == 2){ //含有
          let types = []
          that.curFilter.chapter_type.forEach(item => {
            types.push(item[0])
          })
          filters['include_type'] = types.join(',')
        }
        if(that.curFilter.people_num == 1){
          filters['people_num'] = 0
        }
        else if(that.curFilter.people_num == 2){
          filters['people_num'] = '>0'
        }
        if(that.curFilter.price == 1){
          filters['final_price'] = 0
        }
        else if(that.curFilter.price == 2){
          filters['final_price'] = '>0'
        }
      }
      else {  // 查询课程分类
        if(that.category_lv2_ids != ''){
          filters['category_lv2_ids'] = that.category_lv2_ids.join(',')
        }
        else if(that.category_lv1_id != '' && that.category_lv1_id != 0){
          filters['category_lv1_id'] = that.category_lv1_id
        }
      }

      //按照分类查询
      let cates = []
      that.tagsItem2.forEach((item, index) => {
        if(item.active){
          cates.push(item.id)
        }
      })
      if (cates.indexOf(0) == -1){  // 二级分类不是全部
        filters['category_lv2_ids'] = cates.join(',')
      }
      else if(that.activeItemId != 0){
        filters['category_lv1_id'] = that.activeItemId
      }

      if (that.zone_uuid != null) {
        filters['zone_uuid'] = that.zone_uuid;
      }

      filters['offset'] = (that.pager.currentPage - 1) * that.pager.pageSize
      filters['limit'] = that.pager.pageSize
      filters['needCancel'] = true
      listUserCur(filters).then(res => {
        that.courseItem.push(...res.data);
        that.getFavorLike(that.courseItem)
        that.pager.total = res.total
        this.loading = false
      })
    },
    getCateList() {
      const that = this
      let filters = {'need_count': false, 'in_cur': true}
      if(that.category_lv1_id) {
        filters['category_lv1_id'] = this.category_lv1_id
        filters['level'] = 2
      }
      else if(that.category_lv2_ids){
        filters['category_lv2_ids'] = this.category_lv2_ids.join(',')
      }
      if(that.filters.final_price != undefined){
        filters['final_price'] = that.filters.final_price
      }
      if(that.filters.query != undefined) {
        filters['cur_query'] = that.filters.query
      }

      if (that.zone_uuid != null) {
        filters['zone_uuid'] = that.zone_uuid;
      }

      listCate(filters).then(res => {
        that.tagsItem1 = [{
          id: 0,
          name: '全部',
          active: true,
        }]
        that.tagsItem2 = [{
          id: 0,
          name: '全部',
          active: true
        }]
        for(var i=0; i<res.data.length; i++){
          let cate = {
            id: res.data[i].id,
            name: res.data[i].name,
            active: false
          }
          if(res.data[i].level == 1){
            that.tagsItem1.push(cate)
          }
          else {
            cate['parent_id'] = res.data[i].category_lv1_id
            that.tagsItem2.push(cate)
          }
        }
      })
    },
    clickCate1(index, load=false) {
      let item = this.tagsItem1[index]
      if(item.id != this.activeItemId){
        this.activeItemId = item.id
        for(let i=1; i<this.tagsItem2.length; i++){
          this.tagsItem2[i].active = false
        }
        this.tagsItem2[0].active = true
      }
      if (load){
        this.resetPager()
      }
    },
    clickCate2(index, load=false) {
      for(let i=0; i<this.tagsItem2.length; i++){
        this.tagsItem2[i].active = false
      }
      this.tagsItem2[index].active = true
      if (load){
        this.resetPager()
      }
    },
    filterAuth(id) {
      this.activeAuth = id
      this.pager.currentPage = 1
      this.courseItem = new Array()
      this.getCurList()
    },
    goPath(path) {
      this.$router.push(path)
    },
    getPager(pager) { //获取分页变化后数据
      this.pager = pager
      this.getCurList()
    },
    resetPager() {
      this.courseItem = new Array()
      console.log(this.finished)
      if(this.finished){
        this.pager.currentPage = 0
        this.finished = false
      }
      else {
        this.pager.currentPage = 1
        this.getCurList()
      }
    },
    // updateFilters(val) {
    //   this.filters = Object.assign({}, val)
    //   this.getCurList()
    //   this.getCateList()
    // }
  },
  watch: {
    filters (val) {
      this.courseItem = new Array()
      this.getCurList()
      this.getCateList()
    },
    loading(val) {
      console.log('父组件loading=' + val);
    },
    zone_uuid(val) {
      console.log('watch->zone_uuid:', this.zone_uuid)
      this.getCurList()
      if (this.initCate) {
        this.getCateList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .filter_wrap {
    background:#fff;
    padding:10px;
    position:relative;
    ul {
      line-height:2;
      > li {
        float:left;
        margin-right:15px;
        &.active {
          color:var(--van-primary-color);
        }
      }
    }
    .filter_btn {
      position:absolute;
      right:10px;
      top:13px;
      font-size:20px;
    }
    .filter_active_list {
      > span {
        display:inline-block;
        padding:5px 15px;
        background:#f2f2f2;
        border-radius:20px;
        position:relative;
        > span + span {
          &:before {
            content: '/';
            margin-left:5px;
            margin-right:5px;
          }
        }
        .clear_filter_btn {
          font-size: 18px;
          position: absolute;
          right: -5px;
          top: -5px;
          color: #999;
        }
      }
    }
  }
  .filter_list {
    .van-col {
      padding-left:5px !important;
      padding-right:5px !important;
      span {
        display:block;
        padding:5px;
        text-align:center;
        background:#f2f2f2;
        border-radius:20px;
        margin-bottom:10px;
        &.active {
          background:#e8f7fe;
          color:#22adef;
        }
      }
    }
    .buttons {
      padding-top:10px;
      padding-bottom:10px;
      button {
        margin-left:10px;
      }
    }
  }
  .list_title {
    font-weight:normal;
    font-size:18px;
    margin-top:5px;
    margin-bottom:20px;
    .span-icon {
      display:inline-block;
      width:4px;
      height:18px;
      background: #009dd9;
      position:relative;
      top:2px;
      margin-right:10px;
    }
  }
</style>
